import React from "react";

import { previewTemplate as fetchPreviewTemplate } from "../../../../../api/cp";

export default function useEmailTemplate() {
    const [previewTemplate, setPreviewTemplate] = React.useState(null);

    async function handlePreview(templateId) {
        if (!templateId) {
            alert('"templateId" not found');
            return;
        }

        const preview = await fetchPreviewTemplate(templateId);
        setPreviewTemplate(preview);
    }

    return {
        previewTemplate,
        setPreviewTemplate,
        handlePreview,
    };
}
